export default __webpack_public_path__ + "static/media/info.cadfb069.png";